import CheckoutSummary from "./CheckoutSummary.jsx";
import {
  isValidLandstarPhone,
  LANDSTAR_PHONE_VALIDATION_MESSAGE
} from "../utils/helpers.js";

function CheckoutStep({
  form,
  selectedCountry,
  allowedCountries,
  selectedProducts,
  driverProfile,
  canSubmit,
  submitting,
  error,
  onFormChange,
  onBack,
  onSubmit
}) {
  const hasInvalidPhone = Boolean(form.phone) && !isValidLandstarPhone(form.phone);

  return (
    <div className="landstar-step-content">
      <CheckoutSummary selections={selectedProducts} driverProfile={driverProfile} />

      <form className="landstar-checkout-card" onSubmit={onSubmit}>
        <div className="landstar-section-heading">
          <p className="landstar-kicker">Shipping Details</p>
          <h3>Confirm where the reward should go</h3>
          <p className="landstar-helper-text">
            Complete the delivery details below. You can still return to the previous step if anything needs to change.
          </p>
        </div>

        <div className="landstar-form-grid two-column">
          <input name="firstName" placeholder="First name" value={form.firstName} onChange={onFormChange} required />
          <input name="lastName" placeholder="Last name" value={form.lastName} onChange={onFormChange} required />
        </div>

        <div className="landstar-form-grid two-column">
          <input
            name="email"
            type="email"
            placeholder="Email"
            value={form.email}
            readOnly
            required
          />
          <div className="landstar-field-group">
            <input
              name="phone"
              type="tel"
              inputMode="tel"
              placeholder="Phone"
              value={form.phone}
              onChange={onFormChange}
              aria-invalid={hasInvalidPhone}
              aria-describedby={hasInvalidPhone ? "landstar-phone-error" : undefined}
              required
            />
            {hasInvalidPhone ? (
              <p id="landstar-phone-error" className="landstar-field-error" role="alert">
                {LANDSTAR_PHONE_VALIDATION_MESSAGE}
              </p>
            ) : null}
          </div>
        </div>

        <input
          name="company"
          placeholder="Company or terminal (optional)"
          value={form.company}
          onChange={onFormChange}
        />
        <input name="address1" placeholder="Address line 1" value={form.address1} onChange={onFormChange} required />
        <input name="address2" placeholder="Address line 2 (optional)" value={form.address2} onChange={onFormChange} />

        <div className="landstar-form-grid three-column">
          <input name="city" placeholder="City" value={form.city} onChange={onFormChange} required />
          <select name="state" value={form.state} onChange={onFormChange} required>
            <option value="">{form.country === "CA" ? "Province" : "State / Region"}</option>
            {selectedCountry.regions.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
          <select name="country" value={form.country} onChange={onFormChange} required>
            {allowedCountries.map((country) => (
              <option key={country.code} value={country.code}>
                {country.name}
              </option>
            ))}
          </select>
        </div>

        <div className="landstar-form-grid two-column">
          <input
            name="zip"
            placeholder={form.country === "CA" ? "Postal Code" : "ZIP"}
            value={form.zip}
            onChange={onFormChange}
            required
          />
          <input name="driverCode" value={form.driverCode} readOnly placeholder="Driver code" required />
        </div>

{/*         <div className="landstar-coupon-panel">
          <p className="landstar-helper-text">
            Submission flows through the backend staging process, so this step mirrors the same shipping fields the order processor expects downstream.
          </p>
        </div> */}

        {error ? <p className="landstar-error">{error}</p> : null}

        <hr className="landstar-section-divider" />

        <div className="landstar-inline-actions">
          <button type="button" className="landstar-secondary-button" onClick={onBack}>
            Return to Rewards
          </button>
          <button type="submit" className="landstar-primary-button" disabled={!canSubmit || submitting}>
            {submitting ? "Submitting..." : "Submit Redemption"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CheckoutStep;
